import { render } from "./TheLanguages.vue?vue&type=template&id=869d5c94"
import script from "./TheLanguages.vue?vue&type=script&lang=js"
export * from "./TheLanguages.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__